import React,{useState,useEffect} from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomTextArea from '../../../constants/CustomTextArea';
import CustomButton from '../../../constants/CustomButton';
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {setawardhonourData,getawardhonourData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";


const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required('Required'),
    year: Yup.date()
    .required('Required'),
    award_for: Yup.string()
    .required('Required'),
 
});
const AwardsHonors = (props) =>{
    const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getawardhonourData();
    },[isLoading])
    const columns = [ 
        {title:'Name',field:'name'},
        {title:'Award for',field:'award_for' },
        {title:'Year',field:'year'},
        {title:'Organization',field:'organization'},
        {title:'Detail',field:'detail_about_award'},
        {title:'Venue',field:'venue'},

      ]
    return (
        <div className="customContainer">
            <CustomHeading title="Awards and Honors"/>
            <CustomTableWithAll data={props?.award_honour?.data}  columns={columns} api="/api/award-honour/"  title={'All Awards & Honors'} />
        <CustomLine/>
            <Formik 
                initialValues={{
                    name: "",
                    organization: "",
                    award_for: "",
                    year: "",
                    venue: "",
                    detail_about_award: "",
                    created_by: "admin@test.com"
                   }}
                   validationSchema={validationSchema}
                   onSubmit={values => {
                    console.log(values);
                    props.setawardhonourData(values);
                    setIsLoading(true)
                    
                  }}
            >
            {({ errors, touched,handleChange,handleSubmit }) => (
                <Form onSubmit={handleSubmit} style={{marginTop:0}}>
                    <div className="row">
                        <div className="col-md-6">
                        <CustomInput
                            type={'text'}
                            placeholder={'Enter Awarded Name'}
                            label={'Awarded Name :'}
                            onChange={handleChange('name')}
                            errorText={
                                errors.name && touched.name?errors.name:null
                            }
                        />
                        </div>
                        <div className="col-md-6">
                        <CustomInput
                            type={'date'}
                            placeholder={'Select Year'}
                            label={'Awarded Year :'}
                            onChange={handleChange('year')}
                            errorText={
                                errors.year && touched.year?errors.year:null
                            }
                        />
                        </div>            
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        <CustomTextArea
                            type={'text'}
                            label={'Awarded Organization :'}
                            placeholder={'Enter Awarded Organization'}
                            onChange={handleChange('organization')}
                            rows={2}
                        />	
                        </div>
                        <div className="col-md-6">
                        <CustomTextArea
                            type={'text'}
                            label={'Venue :'}
                            placeholder={'Enter Venue'}
                            onChange={handleChange('venue')}
                            rows={2}
                        />	
                        </div>            
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        <CustomTextArea
                            type={'text'}
                            label={'Awarded for:'}
                            placeholder={'Enter Awarded for'}
                            onChange={handleChange('award_for')}
                            rows={2}
                            errorText={
                                errors.award_for && touched.award_for?errors.award_for:null
                            }
                        />	
                        </div>
                        <div className="col-md-6">
                        <CustomTextArea
                            type={'text'}
                            label={'Any other detail about award:'}
                            placeholder={'Enter other details'}
                            onChange={handleChange('detail_about_award')}
                            rows={3}
                        />	
                        </div>            
                    </div>
                    <CustomButton type="submit" label="Save" />
                </Form>
            )}

            </Formik>
        </div>
    )
}

const mapActionWithProps = {
    getawardhonourData,
    setawardhonourData,
  }
  
  const mapStateWithProps = (state)=>(
    {
        award_honour:state.data.award_honour
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(AwardsHonors);